import LockNode from '@/components/sharedModels/LockNode';
import { WebStorageService } from '@/models/resourcePlanning/services/WebStorageService';

export default class ToolkitModelRoot {
  public readonly commandLockRoot: LockNode = new LockNode('');
  public readonly webStorageService: WebStorageService = new WebStorageService();
}
